import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router";
import axios from "axios";
import { router } from "./router";
import store from "./store/store";
import VueHtmlToPaper from 'vue-html-to-paper';
import './ml';
import "babel-polyfill";

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    "./vendor/dist/css/customReport.css",
  ]
}

Vue.use(VueHtmlToPaper, options);

Vue.use(VueRouter);

const config = window.APP_CONFIG; //config.js dosyasından gelen config bilgilerini alıyoruz

const axiosInstance = axios.create({
  baseURL: config.baseURL + "/api/"
});

store.commit("setConfig", config);

axiosInstance.interceptors.request.use(config => {
  config.headers["Authorization"] = "Bearer " + store.state.user.token;
  return config;
});

Vue.prototype.$axios = axiosInstance;

Vue.config.productionTip = true;

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js